
import _ from 'lodash';

import PropTypes from 'prop-types';

import { FadeInAnimation, Shapes } from '../../components/shared';

import Image from '../../components/shared/image.component';

import useResponsive from '../../../utils/responsive';

import { WordPressImageTransformer } from '../../../utils/wordpress-image-transformer';


const OptionsSection = (props) => {
    
    const { isMobile, isTablet } = useResponsive();
    const { imgSrc, imgAlt, title, icons } = props;

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            const imgSrcDesktop = WordPressImageTransformer(imgSrc, 624, 100);
            return (
                <>
                    <Shapes
                        isPair
                        isCircle
                        isSmallDark
                        speed={0.07}
                        smallRadius={21}
                        largeRadius={50}
                        distanceBetween={{ width: '32%', height: '2%' }}
                        containerMargins={{ left: '-6%', top: '-35%' }}
                        zIndex={3}
                    />
                    <Shapes
                        isDots
                        speed={-0.07}
                        containerMargins={{ top: '50%', left: '40.5%' }}
                        smallMargins={{ width: '65%', height: '30%' }}
                        zIndex={1}
                    />
                    <Image className='option-section-hero-background'
                        src="/assets/images/rectangle_background.png"
                        alt="Hero Background"
                        isOldImage
                    />
                    <Image className='option-section-choose-image' src={imgSrcDesktop} alt={imgAlt} isOldImage />
                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile && isTablet) {
            const imgSrcMobile = WordPressImageTransformer(imgSrc, 500, 100);
            return (
                <>
                    <Shapes
                        isPair
                        isCircle
                        isSmallDark
                        speed={0.07}
                        smallRadius={10.61}
                        largeRadius={25.27}
                        distanceBetween={{ width: '40%', height: '-10%' }}
                        containerMargins={{ left: '-3%', top: '-35%' }}
                        zIndex={3}
                    />
                    <Shapes
                        isDots
                        speed={-0.05}
                        containerMargins={{ top: '50%', left: '47%' }}
                        smallMargins={{ width: '72%', height: '15%' }}
                        zIndex={0}
                    />
                    <Image className='option-section-hero-background'
                        src="/assets/images/rectangle_background.png"
                        alt="Hero Background"
                        isMobile
                        isOldImage
                    />
                    <Image className='option-section-choose-image' src={imgSrcMobile} alt={imgAlt} isOldImage />
                </>
            );
        }
        return null;
    };

    const renderImageSection = () => {
        return (
            <div className='hero-section-image-container'>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
            </div>
        );
    };

    const renderTextSection = () => {
        return (
            <FadeInAnimation>
                <div className='option-section-text-section'>
                    <h4>Monthly Options Available</h4>
                    <p className='choose-section-black-text-opacity'>{props.paragraph}</p>
                    {renderIcons()}
                </div>
            </FadeInAnimation>
        );
    };

    const renderIcons = () => {
        return icons.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <div key={index} className='choose-section-icon-and-text-container'>

                    <div className='about-section-icon-container'>
                        <img src={iconSrc} alt="" className='about-section-icon-image' />
                    </div>

                    <div>
                        <h5>{iconTitle}</h5>
                        
                        <p className='about-section-dark-text-opacity'>{iconParagraph}</p>

                    </div>

                </div>
            );
        });
    };

    return (

        <div>

            <FadeInAnimation>

                <div className='container-root container-root-maxWidthMd option-section-container-settings'>

                    <p className='dummy-header-two option-section-header-two' id="options_header">
                        {title}
                    </p>

                </div>

            </FadeInAnimation>

            <div className='container-root container-root-maxWidthLg'>

                <div className='main-grid-container main-grid-spacing-xs-3 option-section-grid-container'>

                    <div className='main-grid-item main-grid-lg-6 option-section-image'>
                        {renderImageSection()}
                    </div>

                    <div className='main-grid-item main-grid-lg-6 option-section-text-container'>
                        {renderTextSection()}
                    </div>

                </div>

            </div>

        </div>
    );
};

export default OptionsSection;

OptionsSection.propTypes = {
    title: PropTypes.string,
    subHeading: PropTypes.string,
    paragraph: PropTypes.string,
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
    icons: PropTypes.array,
};

